import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <FAQSection />
        <CarouselSection />
        <RankingSection />
        <AboutSection />
        <UpdatesSection />
        <TopicsSection />
        <MediaSection />
        <ContactSection />
        <FeaturesSection />
        <CardsSection />
        <CommentsSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}